const ddadosValidarAlvara = {
  Titulo: "Validar Alvará",
  Campos: {
    NumeroProjeto: {
      Tipo: "text",
      Label: "Número do Projeto",
      Obrigatorio: true
    },
    AnoProjeto: {
      Tipo: "number",
      Label: "Ano do Projeto",
      Obrigatorio: true,
      Tamanho: 4
    },
    NumeroAlvara: {
      Tipo: "text",
      Label: "Número Alvará",
      Obrigatorio: true
    },
    EmissaoAlvara: {
      Tipo: "date",
      Label: "Data de Emissão do Alvará",
      Obrigatorio: true
    }
  }
};

export { ddadosValidarAlvara };
